import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.pagination');
import { OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
    selector: 'wiz-portal-season-pagination',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.pagination/view.scss */
/* src/app/portal.season.pagination/view.scss: no such file or directory */`],
})
export class PortalSeasonPaginationComponent implements OnInit, OnChanges {
    @Input() current: any = 1;
    @Input() start: any = 1;
    @Input() end: any = 1;
    @Input() maxlength: any = 10;
    @Output() pageMove = new EventEmitter<number>();

    public list: Array<number> = [];
    public currentPage: number = 1;
    public pageStart: number = 1;
    public pageEnd: number = 1;
    public prevBlockPage: number = 1;
    public nextBlockPage: number = 1;
    public hasPrevBlock: boolean = false;
    public hasNextBlock: boolean = false;

    public async ngOnInit() {
        this.updatePagination();
    }

    public async ngOnChanges() {
        this.updatePagination();
    }

    private toPageNumber(value: any, fallback: number): number {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) return fallback;
        return Math.max(1, Math.floor(parsed));
    }

    private clampPage(page: number, start: number, end: number): number {
        return Math.max(start, Math.min(page, end));
    }

    private updatePagination() {
        const startPage = this.toPageNumber(this.start, 1);
        const endPage = Math.max(startPage, this.toPageNumber(this.end, startPage));
        const maxLength = this.toPageNumber(this.maxlength, 10);
        const currentPage = this.clampPage(this.toPageNumber(this.current, startPage), startPage, endPage);
        const blockIndex = Math.floor((currentPage - startPage) / maxLength);
        const blockStart = startPage + blockIndex * maxLength;
        const blockEnd = Math.min(blockStart + maxLength - 1, endPage);

        this.currentPage = currentPage;
        this.pageStart = startPage;
        this.pageEnd = endPage;
        this.prevBlockPage = this.clampPage(blockStart - maxLength, startPage, endPage);
        this.nextBlockPage = this.clampPage(blockEnd + 1, startPage, endPage);
        this.hasPrevBlock = blockStart > startPage;
        this.hasNextBlock = blockEnd < endPage;
        this.list = [];
        for (let page = blockStart; page <= blockEnd; page++) {
            this.list.push(page);
        }
    }

    public move(page: any) {
        const targetPage = this.clampPage(this.toPageNumber(page, this.currentPage), this.pageStart, this.pageEnd);
        if (targetPage === this.currentPage) return;
        this.pageMove.emit(targetPage);
    }
}

export default PortalSeasonPaginationComponent;